// extracted by mini-css-extract-plugin
export default {"container":"top-three__container___2lg0b","top-three-skeleton":"top-three__top-three-skeleton___1hvWJ"};